import React from "react"
import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"
import {useMediaQuery} from "../../../../hooks/useMediaQuery"

interface DesktopHeaderContainerProps {
    children: React.ReactNode
    $enableCentreTitle: boolean
}

export const StyledDesktopHeaderContainer = styled("div", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<DesktopHeaderContainerProps>`
    padding-bottom: 0.75rem;
    display: grid;
    grid-template-areas: ${props => (props.$enableCentreTitle ? '"empty title end"' : '"title empty end"')};
    grid-template-columns: ${props => (props.$enableCentreTitle ? "1fr 7fr 1fr" : "20fr 0fr 1fr")};
    width: 100%;
    overflow: hidden;
    @media (min-width: ${breakpoints.values.md}px) {
        grid-template-columns: ${props => (props.$enableCentreTitle ? "1fr 7fr 1fr" : "1fr 0fr 0fr")};
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        grid-template-columns: ${props => (props.$enableCentreTitle ? "4fr 7fr 4fr" : "7fr 0fr 2fr")};
        padding-top: 0.75rem;
        transform: translateY(-0.75rem);
        position: fixed;
        background: white;
        z-index: 2;
        width: calc(75% - 1.5rem);
        max-width: 985px;
        padding-bottom: 0.75rem;
    }
    @media (min-width: ${breakpoints.values.xl}px) {
        width: calc(80% - 1.5rem);
        max-width: 985px;
    }
`
StyledDesktopHeaderContainer.displayName = "StandardDesktopHeaderContainer"

export const DesktopHeaderContainer = ({children, $enableCentreTitle}: DesktopHeaderContainerProps) => {
    const inPageFiltersVisible = useMediaQuery(`(max-width:${breakpoints.values.lg}px)`)
    return (
        <StyledDesktopHeaderContainer data-scrollanchor={!inPageFiltersVisible} $enableCentreTitle={$enableCentreTitle}>
            {children}
        </StyledDesktopHeaderContainer>
    )
}

export default DesktopHeaderContainer
